import { i18n } from 'boot/i18n'

const types = {
  I: i18n.t('entrance'), // ddt_fornitore/rett.inv
  U: i18n.t('exit'), // ddt_cliente/rett.inv/fatt.acc
  S: i18n.t('sale_short'),
  C: i18n.t('buy_from_cash_short'), // acquisto da cassa
  T: i18n.t('transfer'), // ddt_cliente con sede_in e sede_out valorizzate
}
export default {
  namespaced: true,

  getters: {
    toLabelValue: () => Object.entries(types).map(([value, label]) => ({ value, label })),

    getMTypeFromKey: () => key => types[key],
  },
}
